import React, { forwardRef, useRef, useState } from "react"
import { useKeenSlider } from "keen-slider/react"
import useCreativesBlogs from "../../hooks/useCreativeBlogs"
import CommunityImg from "../../Common/CommunityImg/CommunityImg"
import { default as badge1 } from "../../../images/Badges1.svg"
import { default as badge2 } from "../../../images/Creative_community_badge.svg"
import { default as badge3 } from "../../../images/Badges3.svg"
import { default as flags } from "../../../images/creative_get_inspried_left.svg"
import { default as rightArrow } from "../../../images/left-arrow.svg"
import CreativeBlog from "../CreativeBlog/CreativeBlog"
import "./CreativeGetInspired.scss"

const ResizePlugin = slider => {
  const observer = new ResizeObserver(function () {
    slider.update()
  })

  slider.on("created", () => {
    observer.observe(slider.container)
  })
  slider.on("destroyed", () => {
    observer.unobserve(slider.container)
  })
}

const MutationPlugin = slider => {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function () {
      slider.update()
    })
  })
  const config = { childList: true }

  slider.on("created", () => {
    observer.observe(slider.container, config)
  })
  slider.on("destroyed", () => {
    observer.disconnect()
  })
}

const CreativeGetInspired = forwardRef((props, ref) => {
  const data = useCreativesBlogs()
  const {
    posts: { edges: postList },
  } = data
  const [currentSlide, setCurrentSlide] = React.useState(0)
  const [loaded, setLoaded] = useState(false)
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      breakpoints: {
        "(min-width: 480px)": {
          slides: { perView: 2, spacing: 30 },
        },
        "(min-width: 850px)": {
          slides: { perView: 3, spacing: 30 },
        },
        "(min-width: 1200px)": {
          slides: { perView: 4, spacing: 30 },
        },
        "(min-width: 1600px)": {
          slides: { perView: 5, spacing: 30 },
        },
      },
      slides: { perView: 1 },
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel)
      },
      created() {
        setLoaded(true)
      },
    },
    [ResizePlugin, MutationPlugin]
  )

  const initNumRendered = 6
  const numIncrement = 2
  const [numRendered, setNumRendered] = useState(initNumRendered)
  const [displayPostList, setDisplayPostList] = useState(
    postList?.slice(0, initNumRendered) || []
  )
  const eventBlogListRef = useRef(null)

  const openLink = () =>
    window.open(
      `https://www.noissue.co/blog/tag/hash-creativecommunity`,
      "_blank",
      "noopener"
    )

  return (
    <>
      <div className="creative-inspired-container" ref={eventBlogListRef}>
        <div className="creative-inspired-badges">
          <CommunityImg src={badge3} alt="badge1" />
          <CommunityImg src={badge2} alt="badge2" />
          <CommunityImg src={badge1} alt="badge3" />
        </div>
        <div className="creative-inspired-left-flag">
          <CommunityImg src={flags} alt="flags" />
        </div>
        <div className="creative-inspired-details">
          <div className="creative-inspired-title">Get Inspired</div>
          <div className="creative-inspired-subtitle">
            See what all the Creative Buzz is about! Browse tips from Industry
            Experts, find inspiring collaborations, and learn how to level up
            your creative business.
          </div>
        </div>
      </div>
      <>
        <div className="navigation-wrapper">
          <div className="creative-inspired-list keen-slider" ref={sliderRef}>
            {displayPostList.map((post, idx) => {
              return (
                <div className="keen-slider__slide">
                  <CreativeBlog blog={post} key={`blog-${idx}`} />
                </div>
              )
            })}
          </div>
          {loaded && instanceRef.current && (
            <div className="arrows">
              <CommunityImg
                className={`left-arrow ${currentSlide === 0 ? "disabled" : ""}`}
                src={rightArrow}
                alt="left arrow"
                onClick={e =>
                  e.stopPropagation() || instanceRef.current?.prev()
                }
              />
              <CommunityImg
                className={`right-arrow ${
                  currentSlide === instanceRef.current?.track?.details?.maxIdx
                    ? "disabled"
                    : ""
                }`}
                src={rightArrow}
                alt="right arrow"
                onClick={e =>
                  {
                    e.stopPropagation()
                    setDisplayPostList(posts => [...posts, ...postList?.slice(numRendered, numRendered + numIncrement)])
                    setNumRendered(num => num + numIncrement)
                    setTimeout(() => instanceRef.current?.next(), 100)
                  }
                }
              />
            </div>
          )}
        </div>
      </>
      <div className="creative-inspired-button">
        <button onClick={openLink}>See All</button>
      </div>
    </>
  )
})

export default CreativeGetInspired
